import React, { useState, useCallback, useEffect } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";

const TopLayoutContext = React.createContext({
  state: { toplayoutList: {}, toplayout: {} },
  actions: {
    getTopLayout: () => {},
    getTopLayoutList: () => {},
  },
});

const TopLayoutProvider = ({ children }) => {
  const [toplayout, setTopLayout] = useState({});
  const [toplayoutList, setTopLayoutList] = useState([]);
  const [toplayoutSort, setTopLayoutSort] = useState({});

  const getTopLayoutList = useCallback((pageInfo) => {
    HttpAction({
      url: "api/admin/top-area/list",
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        displayYn: pageInfo && pageInfo.displayYn,
        contentType: pageInfo && pageInfo.contentType,
        registStartDate: pageInfo && pageInfo.registStartDate,
        registEndDate: pageInfo && pageInfo.registEndDate,
        contentTitle: pageInfo && pageInfo.contentTitle,
      },
    }).then((res) => {
      if (res.code === 200) {
        setTopLayoutList({ data: res.data, sortFlg: res.sortFlg });
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getTopLayoutSort = useCallback(() => {
    HttpAction({
      url: "api/admin/top-area/list",
      method: "get",
      params: {
        displayYn: true,
      },
    }).then((res) => {
      if (res.code === 200) {
        setTopLayoutSort(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getTopLayout = useCallback((toplayoutId) => {
    HttpAction({
      url: "api/admin/top-area",
      method: "get",
      params: {
        topAreaId: toplayoutId,
      },
    }).then((res) => {
      if (res.code === 200) {
        setTopLayout(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createTopLayout = useCallback(async (toplayoutData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/top-area/save`, toplayoutData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getTopLayoutList({});
        } else {
          res.data.code == 602 &&
            alert(
              "메인 노출 동영상 또는 이미지 최대 3개를 초과할 수 없습니다. 기존 컨텐츠를 삭제 또는 비노출 후 등록해 주세요."
            );
        }
      });
  }, []);

  const updateTopLayout = useCallback(async (toplayoutData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL;
    await axios
      .post(`api/admin/top-area/modify`, toplayoutData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
        } else {
          res.data.code == 602 &&
            alert(
              "메인 노출 동영상 또는 이미지 최대 3개를 초과할 수 없습니다. 기존 컨텐츠를 삭제 또는 비노출 후 등록해 주세요."
            );
        }
      });
  }, []);

  const updateSort = useCallback((sortData, pageInfo) => {
    HttpAction({
      url: "api/admin/top-area/list-swap",
      method: "post",
      data: {
        changeTargetId: sortData.changeTargetId,
        swapType: sortData.swapType,
      },
    }).then((res) => {
      if (res.code === 200) {
        getTopLayoutList(pageInfo);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const updateToplayoutSort = useCallback((sortData, pageInfo, setState) => {
    HttpAction({
      url: "api/admin/top-area/display-sort",
      method: "post",
      data: sortData,
    }).then((res) => {
      if (res.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        });
        getTopLayoutList(pageInfo);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const deleteTopLayout = useCallback((toplayoutId, history, site) => {
    HttpAction({
      url: "api/admin/top-area",
      method: "delete",
      params: {
        topAreaId: toplayoutId,
      },
    }).then((res) => {
      if (res.code === 200) {
        history.push(site);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { toplayout, toplayoutSort, toplayoutList },
    actions: {
      getTopLayoutList,
      getTopLayoutSort,
      getTopLayout,
      createTopLayout,
      updateTopLayout,
      updateSort,
      updateToplayoutSort,
      deleteTopLayout,
    },
  };

  return (
    <TopLayoutContext.Provider value={value}>
      {children}
    </TopLayoutContext.Provider>
  );
};

const { Consumer: TopLayoutConsumer } = TopLayoutContext;

export { TopLayoutProvider, TopLayoutConsumer, TopLayoutContext };

export default TopLayoutContext;
